/**
 * PortalMobileBar — Batch #14.322 : barre fixe en bas de l'écran du portail client (téléphone, < md).
 * Accueil + jusqu'à 4 tuiles choisies par le cabinet (Paramètres › Barre mobile), limitées aux tuiles accessibles au client.
 */
import { Home } from "lucide-react";
import { PORTAL_MOBILE_DEFAULT, PORTAL_MOBILE_MAX, PORTAL_MOBILE_TABS, resolveTabs } from "@/constants/mobileTabs";

export default function PortalMobileBar({ tiles, tabIds, view, onHome, onSelect, primaryColor }) {
  const allowed = new Set(tiles.map((t) => t.id));
  const tabs = resolveTabs(PORTAL_MOBILE_TABS, tabIds, PORTAL_MOBILE_DEFAULT, 99).filter((t) => allowed.has(t.id)).slice(0, PORTAL_MOBILE_MAX);
  if (!tabs.length) return null;
  const badgeOf = (t) => (tiles.find((x) => x.id === t.id) || {}).badge || 0;
  const Item = ({ id, label, icon: Icon, active, badge = 0, onClick }) => (
    <button onClick={onClick} className={`relative flex-1 flex flex-col items-center justify-center gap-0.5 py-1.5 min-h-[54px] text-[10px] font-medium transition active:scale-95 ${active ? "text-white" : "text-white/65"}`}
      aria-label={label} aria-current={active ? "page" : undefined} data-testid={`portal-mobile-tab-${id}`}>
      <span className={`w-9 h-6 rounded-full flex items-center justify-center transition ${active ? "bg-white/20" : ""}`}><Icon className="w-[18px] h-[18px]" /></span>
      {label}
      {badge > 0 && <span className="absolute top-1 right-[18%] min-w-[16px] h-4 px-1 rounded-full bg-red-600 text-white text-[9px] font-bold flex items-center justify-center" data-testid={`portal-mobile-badge-${id}`}>{badge > 99 ? "99+" : badge}</span>}
    </button>
  );
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 border-t border-white/10 pb-safe shadow-[0_-4px_16px_rgba(0,0,0,.18)]"
      style={{ backgroundColor: primaryColor, backgroundImage: "linear-gradient(135deg, rgba(0,0,0,.12), rgba(255,255,255,.14))" }} data-testid="portal-mobile-bar">
      <div className="flex items-stretch">
        <Item id="home" label="Accueil" icon={Home} active={view === "home"} onClick={onHome} />
        {tabs.map((t) => <Item key={t.id} id={t.id} label={t.label} icon={t.icon} active={view === t.id} badge={badgeOf(t)} onClick={() => onSelect(t.id)} />)}
      </div>
    </nav>
  );
}
